<template>
  <div class="bg-white pb-12 h-full">
    <div class="seth-set bg-primary px-6 py-10">
      <p
        @click="handleBack"
        class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
      >
        <feather-icon class="flex" icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
        Go Back
      </p>
      <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
        My Add-ons
      </h2>
    </div>
    <div class="w-full flex w-full bg-white p-8 menucontrol-scroll fixed-top">
      <!-- <div class="w-2/5 p-4">
        <div class="border rounded-lg p-4 w-full">
          <h3 class="col-4f text-2xl bordb pb-2 font-semibold">Add Ons</h3>
          <p class="fsize14 font-medium mt-3">
            Find all the necessary addons you need torun your platform all in
            one place. Recharge credits as peryour requirement and explore new
            medium to
          </p>
        </div>
        <SwiperAddons />
      </div> -->
      <div class="grid grid-cols-2 gap-8 w-full">
        <div
          class="flex items-start cursor-pointer rounded-10px p-4 justify-between border"
          v-for="(item, index) in addOns"
          :key="'item-' + index"
        >
          <div class="flex gap-6 items-center justify-between">
            <img
              v-if="item.addOnId"
              :src="showImage(item.addOnId.images)"
              class="object-contain wh-75px rounded-10px p-3 bg-cas"
              alt="banh"
            />

            <div class="w-full">
              <h3 class="col-4f text-xl mb-0 font-semibold" v-if="item.addOnId">
                {{ item.addOnId.name }}
              </h3>
              <p
                class="font-mediu pt-2 fsize12 text-8f8f8f flex items-center"
                v-if="item.addOnId"
              >
                {{ item.addOnId.quantity
                }}<span class="pl-1">{{ item.addOnId.unit }}</span>
              </p>
              <p
                class="font-mediu pt-1 fsize12 text-8f8f8f flex items-center"
                v-if="item.hasOwnProperty('purchased_on')"
              >
                {{ item.purchased_on }}
              </p>

              <!-- <p
                @click="handleClick"
                class="pt-2 fsize12 text-primary font-semibold text-underline cursor-pointer"
              >
                View Details
              </p> -->
            </div>
          </div>
          <!-- <div class="w-2/12 flex justify-end cursor-pointer">
            <el-input-number
              size="small"
              v-model="item.booster"
              @change="handleChange"
              :min="0"
              :max="10"
            ></el-input-number>
          </div> -->
          <el-tag
            type="success"
            class="rounded-full px-3 font-semibold"
            v-if="item.cloudStatus"
          >
            Active</el-tag
          >
        </div>
      </div>
    </div>
    <el-pagination
      background
      @current-change="
        (value) => {
          currentPage = value;
          getAddOns();
        }
      "
      layout="prev,pager,next"
      :per-size="10"
      :total="pageCount"
    ></el-pagination>
  </div>
</template>
<script>
import addOnsMaster from "@/Apicall/masters/addons.js";
import SwiperAddons from "./SwiperAddons.vue";
import { mapState } from "vuex";
export default {
  components: {
    SwiperAddons,
  },
  data() {
    return {
      addOns: [],
      num: 1,
      pageCount: 0,
      currentPage: 1,
    };
  },
  async mounted() {
    // const data = await this.$store.dispatch("billing/myAddOns");
    // console.log(data);
    this.getAddOns();
  },

  computed: {
    ...mapState("user", ["selectedProject"]),
    ...mapState("admin", ["myAddOns"]),
    ...mapState("projectFile", ["addOnType"]),
  },
  methods: {
    handleClick() {
      this.$router.push({ name: "Add-ons-AddonsDetailSummary" });
    },
    handleChange(value) {
      console.log(value);
    },
    showImage(value) {
      return !!value
        ? `${process.env.VUE_APP_IMAGE_URL}/${value}`
        : default_image;
    },
    async getAddOns() {
      const { data } = await addOnsMaster.myAddOnsRequest({
        paginated: true,
        offset: 10 * this.currentPage - 10,
        projectName: this.selectedProject.projectName,
        cloudStatus: true,
        addOnType: this.addOnType,
      });
      // this.addOns = data.data.data.filter((x) => x.cloudStatus == true);
      this.addOns = data.data.data;
    },

    // async myAddOns() {
    //   await this.$store.dispatch("billing/myAddOns");
    //   const { data } = await addOnsMaster.myAddOns({
    //     projectName: this.selectedProject.projectName,
    //   });
    //   this.addOns = data.data.map((x) => {
    //     return {
    //       ...x,
    //       booster: 0,
    //     };
    //   });
    // },
  },
};
</script>
